import { Outlet } from 'react-router'

import { useIsEmbedded } from '../../embed/child/useIsEmbedded'
import { ProductFlowFooter } from './marketing/components/ProductFlowFooter'
import { ProductFlowNav } from './marketing/components/ProductFlowNav'

/**
 * Layout route for public product flows (DOT funnel, estimate results) —
 * wraps pages with the stripped-back nav and legal footer. Renders no chrome
 * when the page is embedded in a partner iframe.
 */
export function ProductFlowLayout({ theme = 'light' }: { theme?: 'light' | 'dark' } = {}) {
  const isEmbed = useIsEmbedded()
  if (isEmbed) return <Outlet />
  // shrink-0: the app shell (#root) is a flex column, so without a min-h-screen
  // wrapper the page area shrinks to its content's min-height and taller content
  // overflows behind the footer. The outlet area flexes to fill leftover height,
  // so pages use flex-1 (not min-h-screen) and short pages still pin the footer
  // to the bottom of the viewport.
  return (
    <div className="flex min-h-screen shrink-0 flex-col">
      <ProductFlowNav theme={theme} />
      <div className="flex flex-1 flex-col">
        <Outlet />
      </div>
      <ProductFlowFooter
        legalLinks={[
          { label: 'Privacy Policy', href: '/privacy' },
          { label: 'Terms of Service', href: '/terms' },
        ]}
        note={
          <>
            <p>
              Insurance services provided by Cai Insurance Services, a service of Cai Labs, Inc. Agency
              License #6018835. Descriptions are general in nature only. Please refer to the terms and
              conditions of any policies offered or purchased. Insurance products offered are subject to
              application and underwriting requirements. Not all products available in all states. Pricing
              depends on a variety of factors including policyholder location. Not all discounts available in
              all states or on all products.
            </p>
            <p>
              If you are having difficulty viewing or navigating the content on this website, or find a
              feature or functionality that is not fully accessible to you, please email us at{' '}
              <a href="mailto:hello@cai.ai">hello@cai.ai</a>.
            </p>
          </>
        }
      />
    </div>
  )
}

/** ProductFlowLayout on a dark ground — for flows built on an ink-900 background. */
export function DarkProductFlowLayout() {
  return <ProductFlowLayout theme="dark" />
}
